export const NOTIFICATIONS_ROUTES = {
  BASE: "",
  HISTORY: "history",
  CUSTOM: "custom",
  SETTINGS: "settings",
};